module.exports = __webpack_public_path__ + "img/sending_6.91ed3138.png";